import '.a{display:flex;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.f{width:100%;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.o{max-width:480px;}.ssr-plugin'
import '.p{margin:0 auto;}.ssr-plugin'
import '.q{max-width:1280px;}.ssr-plugin'
import '.r{flex:1;}.ssr-plugin'
import '.s{position:relative;}.ssr-plugin'
import '.t{height:100%;}.ssr-plugin'
import '.u{position:absolute;}.ssr-plugin'
import '.v{transform:translateY(-50%);}.ssr-plugin'
import '.w{right:0px;}.ssr-plugin'
import '.x{left:0px;}.ssr-plugin'
import '.y{height:54px;}.ssr-plugin'
import '.z{width:54px;}.ssr-plugin'
import '.a0{border-radius:50%;}.ssr-plugin'
import '.a1{pointer-events:none;}.ssr-plugin'
import '.a2{border:none;}.ssr-plugin'
import '.a3{flex:2;}.ssr-plugin'
import '.a4{bottom:0px;}.ssr-plugin'
import '.a5{padding:16px;}.ssr-plugin'
import '.a6{gap:16px;}.ssr-plugin'
import '.a7{width:calc(100% -32px);}.ssr-plugin'
import '.a8{gap:4px;}.ssr-plugin'
import '.a9{top:16px;}.ssr-plugin'
import '.aa{left:16px;}.ssr-plugin'
import '.ab{right:16px;}.ssr-plugin'
import '.ac{border-radius:6px;}.ssr-plugin'
import { FC, useEffect, useState } from 'react'
import { useIsMobile } from '../hooks/useIsMobile'
import { Layout } from './Layout'
import { Navigation } from '../components/Navigation'
import { Text } from '../components/Text'
import { useTheme } from '../providers/useTheme'
import { useAppCtx } from '../providers/useAppCtx'
import { useContentQuery } from '../hooks/useContentQuery'
import { styled } from 'inlines'
import { Button } from '../components/Button'
import { Video } from 'excelsis-video'
import { Link } from 'wouter'
import { Canva } from '../components/Canva'
// @ts-ignore
import fallbackImage from '../assets/img/Square-Heart.png'
import { useTranslations } from '../hooks/useTranslations'
import { Icon } from '../components/Icon'

export type ThankYouProps = {
  'aria-label'?: {
    nav: string
    footer: string
  }
}

export const ThankYou: FC<ThankYouProps> = ({
  'aria-label': ariaLabelProp = {
    nav: 'Main navigation',
    footer: 'Footer navigation',
  },
}) => {
  const { languages, setVotes } = useAppCtx()
  const { colors, textGradient } = useTheme()
  const isMobile = useIsMobile()
  const { data: currentSequence = {} } = useContentQuery('sequence')
  const { data: thankyouDictionary = {} } = useTranslations('thank_you')

  const [renderCounter, setRenderCounter] = useState(-1)

  const [showPauseButton, setShowPauseButton] = useState(false)
  const [showPlayButton, setShowPlayButton] = useState(true)

  const contestants = currentSequence.round.contestants

  const thanks = window.location.href.split('/')
  const arrOfCandidateDdis = thanks[thanks.length - 1].split('-')

  const [vidIndex, setVidIndex] = useState(0)

  setVotes({})

  const thankYouVideosArr = contestants
    .filter(
      (item) =>
        arrOfCandidateDdis.includes(item.$ddi) && item?.thankyouVideo?.src,
    )
    .map((item) => item.thankyouVideo.src)

  const firstThankYouImage = contestants?.filter(
    (item) => arrOfCandidateDdis.includes(item.$ddi) && item?.image?.src,
  )[0]?.image?.src

  const buttonBgColorFifteenPercentage = colors.primaryAccent.replace(
    /[\d.]+\)$/,
    '0.15)',
  )

  useEffect(() => {
    setRenderCounter(renderCounter + 1)
  }, [vidIndex])

  return (
    <Layout
      style={{
        padding: isMobile ? '0px' : '48px 24px',
        justifyContent: 'start',
        alignSelf: isMobile ? 'center' : undefined,
        gap: 16,
        maxHeight: isMobile ? '100vh' : 'auto',
        overflow: isMobile ? 'hidden' : 'inherit',
      }}
    >
      <Layout.Navbar>
        {!isMobile && (
          <Navigation
            as="nav"
            aria-label={ariaLabelProp.nav}
            isExpandable
            languages={languages}
          />
        )}
      </Layout.Navbar>

      {!thankYouVideosArr?.length ? (
        <Layout.Middle style={{ flex: 1 }}>
          <div className="a d c f i o p"
          >
            <Canva
              style={{ marginBottom: 42 }}
              src={firstThankYouImage || fallbackImage}
            />
            <Text
              variant="title"
              isMultiline
              color="gradient"
              align="center"
              style={{ marginBottom: 12 }}
            >
              {thankyouDictionary.thank_you_prompt}
            </Text>
            <Text
              variant="display-regular"
              isMultiline
              align="center"
              style={{
                marginBottom: 32,
              }}
            >
              {thankyouDictionary.thank_you_details}
            </Text>
            <Link href="/">
              <Button id="thank-you-link-home">
                <Text
                  variant="display-medium"
                  style={{ color: colors.background }}
                  isNotSelectable
                >
                  {thankyouDictionary.back_to_home_button}
                </Text>
              </Button>
            </Link>
          </div>
        </Layout.Middle>
      ) : (
        <Layout.Middle style={{ flex: 1 }}>
          <div className="a f q p"
            style={{
              flexDirection: isMobile ? 'column' : 'row',
              gap: isMobile ? 0 : 48,
              height: isMobile ? '100vh' : 'auto',
            }}
          >
            {/* // SLIDEshow */}
            <div className="r f s t"
              style={{
                aspectRatio: !isMobile ? '9/16' : 'auto',
              }}
              onClick={(e) => e.preventDefault()}
            >
              {isMobile && (
                <VidIndexIndicators
                  vidIndex={vidIndex}
                  videosArr={thankYouVideosArr}
                  style={{ top: 24, zIndex: 1 }}
                />
              )}
              <Video
                key={vidIndex}
                // @ts-ignore
                // type={type}
                onPause={() => {
                  setShowPauseButton(false)
                  setShowPlayButton(true)
                }}
                onPlay={() => {
                  setShowPauseButton(false)
                  setShowPlayButton(false)
                }}
                onMouseEnter={() => !showPlayButton && setShowPauseButton(true)}
                onMouseLeave={() => setShowPauseButton(false)}
                //autoPlay={vidIndex !== 0}
                autoPlay
                playsInline
                onEnded={() =>
                  vidIndex === thankYouVideosArr.length - 1
                    ? setVidIndex(0)
                    : setVidIndex(vidIndex + 1)
                }
                src={thankYouVideosArr[vidIndex]}
                style={{
                  minHeight: '100%',
                  borderRadius: isMobile ? '0px' : '16px',
                  width: isMobile ? '132vw' : 'auto',
                  transform: isMobile ? 'translateX(-16vw)' : 'none',
                  overflow: 'hidden',
                  objectFit: 'cover',
                  '& img': { borderRadius: '16px' },
                }}
              >
                {showPlayButton && (
                  <styled.button className="u v w x y z a d c p a0 a1 a2"
                    style={{
                      top: isMobile ? '50vh' : '50%',
                      background: textGradient
                        ? `linear-gradient(90deg, ${colors.primaryAccent} 0%, ${colors.secondaryAccent} 100%)`
                        : colors.primaryAccent,
                      color: colors.background,
                      '&svg': { width: '90px' },
                    }}
                  >
                    <Icon
                      variant="play"
                      color={colors.background}
                      style={{ width: 34, height: 34 }}
                    />
                  </styled.button>
                )}
                {showPauseButton && (
                  <button className="u v w x p y z a0 a2 a1"
                    style={{
                      top: isMobile ? '50vh' : '50%',
                      backgroundColor: buttonBgColorFifteenPercentage,}}
                  >
                    <Icon
                      variant="pause"
                      color={colors.background}
                      style={{ width: 34, height: 34 }}
                    />
                  </button>
                )}

                <Video.Loader />
                {!isMobile && (
                  <VidIndexIndicators
                    vidIndex={vidIndex}
                    videosArr={thankYouVideosArr}
                    style={{}}
                  />
                )}
              </Video>
            </div>

            <div className="a d c a3 f a4"
              style={{
                borderRadius: isMobile ? '0px' : 16,
                position: isMobile ? 'fixed' : 'inherit',
                paddingBottom: isMobile ? '24px' : 0,
                background: isMobile
                  ? 'linear-gradient(0deg,rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 100%)'
                  : 'linear-gradient(0deg, var(--Primary-accent, rgba(174, 43, 171, 0.05)) 0%, var(--Primary-accent, rgba(174, 43, 171, 0.05)) 100%)',
              }}
            >
              <div className="o a5">
                <Text
                  color={isMobile ? '#fff' : 'gradient'}
                  variant="title"
                  isMultiline
                  align="center"
                  style={{ marginBottom: 12 }}
                >
                  {thankyouDictionary.thank_you_prompt}
                </Text>
                <Text
                  variant="display-regular"
                  isMultiline
                  align="center"
                  style={{
                    marginBottom: 32,
                    color: isMobile ? 'white' : colors.textPrimary,
                  }}
                >
                  {thankyouDictionary.thank_you_details}
                </Text>
                <div className="a d c a6"
                  style={{
                    flexDirection: isMobile ? 'column' : 'row',}}
                >
                  {thankYouVideosArr.length === 1 ? (
                    <></>
                  ) : (
                    <Button
                      id="thank-you-play-next"
                      leadIcon={
                        thankYouVideosArr.length === 1 ? 'play' : undefined
                      }
                      style={{ width: isMobile ? '100%' : 'auto' }}
                      color={colors.background}
                      on={{
                        click: () => {
                          if (vidIndex === thankYouVideosArr.length - 1) {
                            setVidIndex(0)
                          } else {
                            setVidIndex(vidIndex + 1)
                          }
                        },
                      }}
                    >
                      <Text
                        variant="display-medium"
                        style={{ color: colors.background }}
                        isNotSelectable
                      >
                        {thankyouDictionary.play_next_button}
                      </Text>
                    </Button>
                  )}
                  <Link href="/" style={{ width: isMobile ? '100%' : 'auto' }}>
                    <Button
                      id="thank-you-link-home"
                      style={{
                        width: isMobile ? '100%' : 'auto',
                        backgroundColor: buttonBgColorFifteenPercentage,
                      }}
                    >
                      <Text
                        variant="display-medium"
                        style={{ color: colors.primaryAccent }}
                        isNotSelectable
                      >
                        {thankyouDictionary.back_to_home_button}
                      </Text>
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </Layout.Middle>
      )}

      <Layout.Footer>
        {!isMobile && (
          <Navigation
            as="footer"
            aria-label={ariaLabelProp.footer}
            languages={languages}
          />
        )}
      </Layout.Footer>
    </Layout>
  )
}

const VidIndexIndicators = ({ videosArr, vidIndex, style }) => {
  return (
    <styled.div className="a a7 u d a8 a9 aa ab"
      style={{
        ...style,
      }}
    >
      {videosArr?.map((item, idx) => (
        <div className="r ac"
          key={idx}
          style={{
            background: idx === vidIndex ? 'white' : 'rgba(255,255,255,0.25)',
            height: idx === vidIndex ? 4 : 1,
          }}
        />
      ))}
    </styled.div>
  )
}
